module.exports = __webpack_public_path__ + "static/media/Profile-placeholder.8da96ddb.svg";